import React from 'react';

import './formLoader.css';

const FormLoader = () => (
  <div className="form-loader">
    <div className="form-loader__header pulse" />

    <div className="form-loader__body">
      <div className="form-loader__title pulse" />
      <div className="form-loader__line pulse" />
      <div className="form-loader__line form-loader__line--short pulse" />
    </div>
  </div>
);

export default FormLoader;
